import React from 'react'
import { ToggleButtonGroup } from '@mui/material'

import { GoalScope } from '../../../../../../../pure-js/types/CoachTypes'
import { TESTIDS } from '../../../../../config/testids'
import { buildAriaPillToggleGroupSx } from '../../../../../shared/coachPreferences/coachSurfaceStyles'
import { useTranslation } from '../../../../../shared/hooks/useIntractionTranslate'
import { coachFocusButtonSx } from '../coachPageStyles'
import { CoachFocusOption } from './CoachFocusOption'

type CoachFocusSwitchProps = {
  focus: GoalScope
  onChange: (focus: GoalScope) => void
}

const COACH_FOCUSES = Object.values(GoalScope)

/** Which conversation a leader is having with Aria; drawn as a sibling of the mode switch it sits beside. */
export const CoachFocusSwitch = ({ focus, onChange }: CoachFocusSwitchProps) => {
  const { t } = useTranslation()

  // MUI reports null when the active button is clicked again; the current focus is kept.
  const handleChange = (_event: React.MouseEvent<HTMLElement>, nextFocus: GoalScope | null) => {
    if (nextFocus) onChange(nextFocus)
  }

  return (
    <ToggleButtonGroup
      exclusive
      value={focus}
      aria-label={t('gamer.ariaCoach.focus.label')}
      data-testid={TESTIDS.COACH_FOCUS_SWITCH}
      onChange={handleChange}
      sx={buildAriaPillToggleGroupSx(coachFocusButtonSx)}
    >
      {COACH_FOCUSES.map((candidate) => (
        <CoachFocusOption key={candidate} value={candidate} />
      ))}
    </ToggleButtonGroup>
  )
}
